export enum BusinessPartnerRoutes {
  Devices = 'devices',
  Admins = 'admins',
  Doctors = 'doctors',
  FamilyUsers = 'family-users',
  Patients = 'patients',
  MedicalOperators = 'medical-operators',
  MyPartners = 'my-partners',
}
